export const logError = (err, query, componentName, variables) => {
  if (process.env.NODE_ENV !== 'production') {
    console.log(componentName, query, err, variables);
  }
};
